export const LIVE_STREAM_COPY = {
  showStream: 'Show stream',
  hideStream: 'Hide stream',
  previous: 'Previous',
  liveEventOverview: 'Live Event Overview',
};
